import { css } from 'styled-components';
import { pickColor } from 'themes/helpers/pickColor';

const motives = {
  default: css`
    label {
      padding: 1rem 2rem 1rem 0;
      width: 14rem;

      font-weight: 600;
      font-family: 'LFT Zeno Condensed', sans-serif;
      font-size: 1.6rem;

      letter-spacing: 0.1rem;
      text-transform: uppercase;

      color: ${pickColor('black')};
    }

    textarea {
      flex-grow: 1;

      min-height: 6.6rem;
      padding: 0.6rem 1.2rem;

      border: 0.1rem solid ${pickColor('borderColorLight')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      font-size: 1.2rem;
    }
  `,
  customer: css`
    flex-direction: column;

    label {
      font-weight: 600;
      font-size: 1.2rem;
      font-family: 'LFT Zeno', sans-serif;

      letter-spacing: 0.05rem;
      text-transform: capitalize;

      white-space: nowrap;

      color: ${pickColor('black')};
    }

    textarea {
      width: 100%;
      min-height: 10rem;
      padding: 0.6rem 1.2rem;

      border: 0.1rem solid ${pickColor('black')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      font-size: 1.2rem;
    }
  `,
  chat: css`
    flex-direction: column;

    textarea {
      width: 100%;
      padding: 0.6rem 1.2rem;

      border: 0.1rem solid ${pickColor('black')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      font-size: 1.2rem;
    }
  `,
};

export type TextAreaMotives = keyof typeof motives;

const pickMotive = (motive: TextAreaMotives) => motives[motive];

export { pickMotive };
